import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do family law attorneys differentiate beyond price?",
    "a": "Process clarity, attorney empathy, and matter-specific content. Prospects researching divorce read for hours before they call. Sites that answer their questions, not just sell, convert at higher rates and higher fees."
  },
  {
    "q": "Is SEO worth it for family law?",
    "a": "Yes — 'divorce attorney', 'child custody lawyer', and 'family law' are among the highest-volume legal searches. Local ranking captures the entire consideration window."
  },
  {
    "q": "Should family law firms run Google Ads?",
    "a": "Yes — high-asset divorce and contested custody justify CPCs. We build campaigns with intake screening so unqualified consultations drop off before they hit your calendar."
  },
  {
    "q": "Do you handle high-net-worth and complex family law?",
    "a": "Yes — high-asset divorce, business valuation, and complex custody each get dedicated pages and positioning that signals you're the right attorney for that level of work."
  },
  {
    "q": "What about mediation and collaborative divorce?",
    "a": "Growing niches with high search intent and low competition. We build out mediation and collaborative pages as separate offerings when they fit the firm."
  }
];

export const Route = createFileRoute("/family-law-attorney-marketing-colorado")({
  head: () =>
    industryMarketingHead("Family Law Attorney", "family law firm", "family-law-attorney-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Family Law Attorney"}
      industryLower={"family law firm"}
      slug={"family-law-attorney-marketing-colorado"}
      subheadline={"We help Colorado family law attorneys reach clients at the moment they decide they need help — divorce, custody, support — without competing on price."}
      painPoints={["Prospects shop by price because your site doesn't differentiate","Big firms dominate the obvious keywords; you don't show up","Consultation requests are unqualified or already shopping competitors"]}
      serviceDescriptions={{
        seo: "Rank for divorce, custody, child support, modifications, mediation, and every family law matter across every Colorado market.",
        googleMaps: "Own 'divorce attorney near me' in the Map Pack with empathy-led reviews and attorney bios.",
        webDesign: "Matter-specific landing pages with attorney credibility, process clarity, and trust-first intake forms.",
        ppc: "Profitable Google Ads tuned to divorce, custody, and high-asset family law searches.",
        geoAi: "Get cited when prospects ask ChatGPT 'best divorce attorney in Denver' or 'family law near me'.",
        socialMedia: "Empathetic, educational content that builds trust during the consideration window.",
      }}
      testimonial={{"quote":"Lead quality changed completely. We attract clients who want our process — not the cheapest hourly rate.","role":"Family Law Attorney","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Family law attorney marketing in Colorado Springs","description":"Reach divorce and custody clients across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Family law attorney marketing in Denver","description":"Compete in Denver's competitive family law market."},{"to":"/castle-rock-digital-marketing","label":"Family law attorney marketing in Castle Rock","description":"High-asset divorce and custody work across Castle Rock and Douglas County."}]}
    />
  ),
});
